import type { FC } from 'react';

import { CLICK_IDS } from '@sunflower-games/analytics-events';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { ONBOARDING_CONFIG } from '../../features/onboarding/constants';
import { analytics } from '../../services/analytics';
import { useFlag } from '../../services/launchDarkly';
import { useStores } from '../../stores/useStores';
import Button from '../buttons/Button';

import styles from './Controls.module.scss';

interface IControls {
  closeMenu: () => void;
  setReferenceElement: null | ((el: HTMLElement | null) => void);
}

export const Controls: FC<IControls> = observer((props) => {
  const { appStore, userStore, uiStore, onboardingStore, loyaltyProgramStore, pocStore } = useStores();
  const { t } = useTranslation();
  const preventPurchase = useFlag('prevent_purchase', false);
  const redeemModeAvailable = useFlag('redeem_mode_available', true);

  const openBuyDialog = () => {
    void analytics.sendEvent('purchase', {
      step_name: 'store',
      event_action: 'click',
      triggered_by: 'click',
      store_type: 'store',
      store_segment: loyaltyProgramStore.currentTierKey,
      button_location: 'menu',
      click_id: CLICK_IDS.PURCHASE.MENU_OPEN_STORE,
      store_key: appStore.currentStore?.key || '',
      sign_up_date: userStore.profile?.createdAt || '',
    });

    uiStore.setOpenFullPageDialog(preventPurchase ? 'prevent_purchase' : 'store');
    props.closeMenu();
  };

  const openRedeemDialog = () => {
    void analytics.sendEvent('redeem_menu', {
      event_action: 'click',
      triggered_by: 'click',
      button_location: 'side-menu',
    });
    uiStore.setOpenFullPageDialog('redeem');
    props.closeMenu();
  };

  const showOnboarding = onboardingStore.step === ONBOARDING_CONFIG.REDEEM;

  return (
    <div ref={props.setReferenceElement} className="side-menu__buttons">
      <Button btnType="main" handleOnClick={openBuyDialog}>
        {t('profile.menu.purchase')}
      </Button>
      {redeemModeAvailable && (
        <Button
          btnType="orange"
          classNameWrapper={classNames({
            'side-menu__buttons--onboarding': showOnboarding,
            'onboarding-arrow': showOnboarding,
            [styles.hangingPocMarker]: pocStore.shouldShowHangingSessionMarker,
          })}
          handleOnClick={openRedeemDialog}
        >
          {t('common.redeemLowerCase')}
        </Button>
      )}
    </div>
  );
});
